import React, { Fragment, Component  } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';


import { TitledCard } from 'Components/';
import { NUTRITION_STANDARDS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { NutritionStandardsReportFieldEnum as Fields } from 'Common/FieldEnum';
import {
  SelectField
} from 'Common/SemanticWrapper';

class NutritionStandardsReportFormContainer extends Component {
  
  static propTypes = {
    nutritionStandards: PropTypes.array,
    nutritionStandardsLoading: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    nutritionStandards: [],
    nutritionStandardsLoading: false,
    loading: false,
  };

  render() {
    const {
      nutritionStandards,
      nutritionStandardsLoading,
      loading
    } = this.props;


    return(
    <Fragment>
      <Form name={NUTRITION_STANDARDS_REPORT_FORM_NAME}>
        <TitledCard title={'Filters'}>
          <Grid>
            <Grid.Row>
            <Grid.Column width={10}>
                <Field
                  label="Nutrition Standard"
                  name={Fields.NutritionStandard}
                  component={SelectField}
                  options={nutritionStandards}
                  loading={nutritionStandardsLoading}
                  disabled={
                    !nutritionStandards.length ||
                    nutritionStandardsLoading ||
                    loading
                  }
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    </Fragment>
    )
                }
              }

const validate = (values) => {
  let errors = {};

  if (!values[Fields.NutritionStandard]) {
    errors[Fields.NutritionStandard] = 'Nutrition Standard is required';
  }

  return errors;
};

const NutritionStandardsReportFormForm = reduxForm({
  form: NUTRITION_STANDARDS_REPORT_FORM_NAME,
  validate,
})(NutritionStandardsReportFormContainer);

const mapStateToProps = (state) => {

  return {
   state
  };
};

export const NutritionStandardsReportForm = connect(
  mapStateToProps,
  null
)(NutritionStandardsReportFormForm);



// WEBPACK FOOTER //
// ./src/pages/nutritionstandardsreport/components/NutritionStandardsReportForm.js